import { Colors } from './types'

export const baseColors = {
  purple: '#9239FF',
  purpleHover: '#7300FF',

  gray1: '#EDEBF6',
  gray2: '#EDEBF7',
  gray3: '#D1D3DA',
  gray4: '#D1D3DB',
  gray5: '#BCBEC4',
  gray6: '#999999',
  gray7: '#333333',
  gray8: '#404040',
  gray9: '#2B2B2B',
  gray10: '#1A1A1A',
  gray11: '#141414',

  red: '#FF2F23',
  green: '#6DE833',
  yellow: '#FFB800',
  magenta: '#FF029A',
  cyan: '#03F5FF',

  white: '#FFFFFF',
  white2: 'rgba(255, 255, 255, 0.8)',
  white3: 'rgba(255, 255, 255, 0.3)',
  white4: 'rgba(255, 255, 255, 0.4)',
  white5: 'rgba(255, 255, 255, 0.5)',
  white6: '#818C92',

  black: '#000000',
  offWhite: '#F2F5F8',

  divider: '#272E39',

  contrast: '#8F96A3',
  contrastOpacity: 'rgba(143, 150, 163, 0.3)'
}

export const lightColors: Colors = {
  ...baseColors,
  background: '#000',
  backgroundActive: '#0A0A0A',
  backgroundContrast: '#0F0F0F',
  text: '#EDEBF6'
}

export const darkColors: Colors = {
  ...baseColors,
  background: '#000',
  backgroundActive: '#0A0A0A',
  backgroundContrast: '#0F0F0F',
  text: '#EDEBF6'
}
